import {FC, ReactNode} from 'react'
import s from './style.module.css'
import {clsx} from 'clsx'

interface Props {
  className?: string
  children?: ReactNode
}

const CardDetails: FC<Props> = ({children, className}) => {
  const css = clsx(s.info, className)
  return <div className={css}>{children}</div>
}

export default CardDetails
